import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-app flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full bg-white rounded-3xl card-shadow p-10 text-center">
        <div className="w-16 h-16 rounded-full bg-app-secondary flex items-center justify-center mx-auto">
          <XCircle size={30} className="text-ink-muted" />
        </div>
        <h1 className="font-serif text-2xl font-bold text-ink mt-6">Payment cancelled</h1>
        <p className="text-ink-soft text-sm mt-2">No charge was made. Whenever you're ready, your reset is waiting.</p>
        <button
          data-testid="retry-checkout-btn"
          onClick={() => navigate("/checkout")}
          className="mt-8 w-full bg-brand hover:bg-[var(--brand-hover)] text-white font-semibold py-3.5 rounded-full transition-colors"
        >
          Return to checkout
        </button>
      </div>
    </div>
  );
}
